module.exports = __webpack_public_path__ + "static/img/cardimgImgbb.570d19b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/cardimgImgbb.jpg
// module id = 0vNu
// module chunks = 7